var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Content",
    { attrs: { id: "scanTestTubeLog" } },
    [
      _c(
        "div",
        { attrs: { slot: "search" }, slot: "search" },
        [
          _c(
            "Form",
            {
              attrs: { "label-width": 45, model: _vm.search, id: "searchForm" },
            },
            [
              _c(
                "Row",
                [
                  _c(
                    "Col",
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "条形码", "label-width": 60 } },
                        [
                          _c("el-input", {
                            attrs: { maxlength: 13, clearable: true },
                            on: {
                              input: function ($event) {
                                return _vm.toInt()
                              },
                            },
                            model: {
                              value: _vm.search.barCode,
                              callback: function ($$v) {
                                _vm.$set(_vm.search, "barCode", $$v)
                              },
                              expression: "search.barCode",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "姓名" } },
                        [
                          _c("el-input", {
                            attrs: { maxlength: 50, clearable: true },
                            model: {
                              value: _vm.search.name,
                              callback: function ($$v) {
                                _vm.$set(_vm.search, "name", $$v)
                              },
                              expression: "search.name",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    [
                      _c(
                        "FormItem",
                        {
                          attrs: {
                            label: "体检任务",
                            prop: "taskId",
                            "label-width": 75,
                          },
                        },
                        [
                          _c(
                            "el-select",
                            {
                              staticStyle: { "min-width": "350px" },
                              attrs: {
                                placeholder: "体检任务",
                                clearable: "",
                                filterable: "",
                                size: "small",
                                transfer: "true",
                                "popper-append-to-body": false,
                              },
                              model: {
                                value: _vm.search.taskId,
                                callback: function ($$v) {
                                  _vm.$set(
                                    _vm.search,
                                    "taskId",
                                    typeof $$v === "string" ? $$v.trim() : $$v
                                  )
                                },
                                expression: "search.taskId",
                              },
                            },
                            _vm._l(_vm.taskList, function (item) {
                              return _c("el-option", {
                                key: item.value,
                                staticStyle: { "min-width": "350px" },
                                attrs: { label: item.label, value: item.value },
                              })
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "发管" } },
                        [
                          _c(
                            "Select",
                            {
                              staticStyle: { "min-width": "95px" },
                              attrs: { clearable: true },
                              model: {
                                value: _vm.search.tubeStatus,
                                callback: function ($$v) {
                                  _vm.$set(_vm.search, "tubeStatus", $$v)
                                },
                                expression: "search.tubeStatus",
                              },
                            },
                            _vm._l(_vm.tubeStatusList, function (item) {
                              return _c(
                                "Option",
                                {
                                  key: item.value,
                                  attrs: { value: item.value },
                                },
                                [_vm._v(_vm._s(item.label))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "拒检" } },
                        [
                          _c(
                            "Select",
                            {
                              staticStyle: { "min-width": "95px" },
                              attrs: { clearable: true },
                              model: {
                                value: _vm.search.rejectStatus,
                                callback: function ($$v) {
                                  _vm.$set(_vm.search, "rejectStatus", $$v)
                                },
                                expression: "search.rejectStatus",
                              },
                            },
                            _vm._l(_vm.rejectStatusList, function (item) {
                              return _c(
                                "Option",
                                {
                                  key: item.value,
                                  attrs: { value: item.value },
                                },
                                [_vm._v(_vm._s(item.label))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "抽血" } },
                        [
                          _c(
                            "Select",
                            {
                              staticStyle: { "min-width": "95px" },
                              attrs: { clearable: true },
                              model: {
                                value: _vm.search.checkStatus,
                                callback: function ($$v) {
                                  _vm.$set(_vm.search, "checkStatus", $$v)
                                },
                                expression: "search.checkStatus",
                              },
                            },
                            _vm._l(_vm.checkStatusList, function (item) {
                              return _c(
                                "Option",
                                {
                                  key: item.value,
                                  attrs: { value: item.value },
                                },
                                [_vm._v(_vm._s(item.label))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "加项" } },
                        [
                          _c(
                            "Select",
                            {
                              staticStyle: { "min-width": "80px" },
                              attrs: { clearable: true },
                              model: {
                                value: _vm.search.optionsStatus,
                                callback: function ($$v) {
                                  _vm.$set(_vm.search, "optionsStatus", $$v)
                                },
                                expression: "search.optionsStatus",
                              },
                            },
                            _vm._l(_vm.optionsStatusList, function (item) {
                              return _c(
                                "Option",
                                {
                                  key: item.value,
                                  attrs: { value: item.value },
                                },
                                [_vm._v(_vm._s(item.label))]
                              )
                            }),
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c(
                    "Col",
                    [
                      _c(
                        "FormItem",
                        { attrs: { label: "日期" } },
                        [
                          _c("DatePicker", {
                            staticStyle: { width: "114px" },
                            attrs: {
                              type: "date",
                              editable: false,
                              placeholder: "起始日期",
                              format: "yyyy-MM-dd",
                            },
                            on: { "on-change": _vm.changestart },
                            model: {
                              value: _vm.search.startDate,
                              callback: function ($$v) {
                                _vm.$set(_vm.search, "startDate", $$v)
                              },
                              expression: "search.startDate",
                            },
                          }),
                          _c("DatePicker", {
                            staticStyle: { width: "114px" },
                            attrs: {
                              type: "date",
                              editable: false,
                              placeholder: "结束日期",
                              format: "yyyy-MM-dd",
                            },
                            on: { "on-change": _vm.changeend },
                            model: {
                              value: _vm.search.endDate,
                              callback: function ($$v) {
                                _vm.$set(_vm.search, "endDate", $$v)
                              },
                              expression: "search.endDate",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _c("Col", [
                    _c(
                      "div",
                      { staticStyle: { display: "flex" } },
                      [
                        _vm._v("  "),
                        _c(
                          "Button",
                          {
                            attrs: { type: "primary" },
                            on: { click: _vm.query },
                          },
                          [_vm._v("查询")]
                        ),
                      ],
                      1
                    ),
                  ]),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-table",
        {
          staticStyle: { width: "100%" },
          attrs: {
            data: _vm.dataList,
            "header-cell-style": {
              background: "#f8f8f9",
              color: "#515a6e",
              "text-align": "center",
            },
            "row-class-name": _vm.tableRowClassName,
            "highlight-current-row": "",
            "highlight-selection-row": "",
            "row-key": "id",
            "max-height": _vm.tableHeight,
          },
          on: { "row-click": _vm.selectrow },
        },
        [
          _c("el-table-column", {
            attrs: {
              fixed: "",
              align: "center",
              prop: "barCode",
              label: "条形码",
              "min-width": "130",
            },
          }),
          _c("el-table-column", {
            attrs: {
              fixed: "",
              align: "center",
              prop: "name",
              label: "姓名",
              "min-width": "100",
            },
          }),
          _c("el-table-column", {
            attrs: {
              fixed: "",
              align: "center",
              prop: "schoolName",
              label: "学校",
              "show-overflow-tooltip": "",
              "min-width": "200",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "tubeStatus",
              label: "发管",
              "min-width": "80",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          size: "small",
                          type: row.tubeStatus === 2 ? "primary" : "danger",
                          "disable-transitions": "",
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            row.tubeStatus == 2
                              ? "已发管"
                              : row.tubeStatus == 1
                              ? "未发管"
                              : "未知"
                          )
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "rejectStatus",
              label: "拒检",
              "min-width": "80",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          size: "small",
                          type: row.rejectStatus === 1 ? "primary" : "danger",
                          "disable-transitions": "",
                        },
                      },
                      [
                        _vm._v(
                          _vm._s(
                            row.rejectStatus == 2
                              ? "是"
                              : row.rejectStatus == 1
                              ? "否"
                              : "未知"
                          )
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "checkStatus",
              label: "抽血",
              "min-width": "100",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          size: "small",
                          type:
                            row.checkStatus === 2
                              ? "warning"
                              : row.checkStatus === 3
                              ? "primary"
                              : "danger",
                          "disable-transitions": "",
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              _vm.checkStatusList.filter(
                                (u) => u.value === row.checkStatus
                              )[0].label
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "optionsStatus",
              label: "加项",
              "min-width": "80",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c(
                      "el-tag",
                      {
                        attrs: {
                          size: "small",
                          type:
                            row.optionsStatus === 1
                              ? "primary"
                              : row.optionsStatus === 2
                              ? "success"
                              : "",
                          "disable-transitions": "",
                        },
                      },
                      [
                        _vm._v(
                          "\n          " +
                            _vm._s(
                              row.optionsStatus == 1
                                ? "无加项"
                                : row.optionsStatus == 2
                                ? "有加项"
                                : ""
                            ) +
                            "\n        "
                        ),
                      ]
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "reason",
              label: "原因",
              "min-width": "200",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "remark",
              label: "备注",
              "min-width": "200",
            },
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "sources",
              label: "来源",
              "min-width": "80",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _vm._v(
                      _vm._s(
                        row.sources == 1
                          ? "pc端"
                          : row.sources == 2
                          ? "小程序"
                          : row.sources == 3
                          ? "定时器"
                          : ""
                      )
                    ),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              align: "center",
              prop: "operator",
              label: "最后操作人",
              "min-width": "150",
            },
            scopedSlots: _vm._u([
              {
                key: "default",
                fn: function ({ row }) {
                  return [
                    _c("div", [_vm._v(_vm._s(row.operatorAccount))]),
                    _c("div", [_vm._v(_vm._s(row.operator))]),
                  ]
                },
              },
            ]),
          }),
          _c("el-table-column", {
            attrs: {
              fixed: "right",
              align: "center",
              prop: "createTime",
              label: "操作时间",
              "min-width": "180",
            },
          }),
        ],
        1
      ),
      _c("Page", {
        staticStyle: { "margin-top": "10px" },
        attrs: {
          total: _vm.pageList.total,
          current: _vm.pageList.currentPage,
          "page-size": _vm.pageList.pageSize,
          "show-elevator": "",
          "show-sizer": "",
          "show-total": "",
          "page-size-opts": [10, 30, 50, 100],
        },
        on: {
          "on-change": _vm.chagecurrent,
          "on-page-size-change": _vm.chagepagesize,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }